// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOctScan_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 18.9991C8.9188 18.9991 5.86384 18.2956.748657 16.967L1.25145 15.0312C6.40294 16.3693 9.21464 16.9991 12.0001 16.9991 14.7855 16.9991 17.5972 16.3693 22.7487 15.0312L23.2515 16.967C18.1363 18.2956 15.0813 18.9991 12.0001 18.9991ZM7.1766 12.7519C4.55796 11.5281 2.70425 12.0092 1.50421 12.7099L.495728 10.9828C2.22902 9.97074 4.77531 9.4221 8.02333 10.94 9.63045 11.691 10.8489 12.0073 12.0117 11.9999 13.1784 11.9925 14.3903 11.6588 15.9871 10.935 19.2186 9.4703 21.7604 9.96328 23.5045 10.9824L22.4954 12.7092C21.3062 12.0143 19.448 11.5622 16.8128 12.7566 15.0911 13.537 13.5863 13.99 12.0243 13.9999 10.4584 14.0098 8.93605 13.5741 7.1766 12.7519Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 2H2V22H22V2ZM0 0V24H24V0H0Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9999 25.0006C11.8375 25.0006 7.70457 23.9562.72522 21.9621L1.27466 20.0391C8.29531 22.045 12.1624 23.0006 15.9999 23.0006 19.8375 23.0006 23.7046 22.045 30.7252 20.0391L31.2747 21.9621C24.2953 23.9562 20.1624 25.0006 15.9999 25.0006ZM9.66616 16.8168C5.91526 15.4884 3.17937 16.0038 1.40467 16.7891L.595337 14.9602C2.82064 13.9754 6.08475 13.4267 10.3338 14.9315 12.5619 15.7206 14.3116 16.075 16.0198 16.0668 17.7305 16.0585 19.4681 15.6865 21.6751 14.9283 25.9105 13.4734 29.1713 13.9705 31.4049 14.9597L30.5951 16.7884C28.8287 16.0062 26.0895 15.5266 22.3249 16.8198 20.0067 17.6162 18.0397 18.0571 16.0294 18.0667 14.0165 18.0764 12.0288 17.6535 9.66616 16.8168Z" class="svg-bg"/>
  <path class="svg-bg-stroke" stroke-width="2" d="M1 1H31V31H1z"/>
</svg>
`;
/**
 * IconMedOctScan is a generated icon component.
 */
let IconMedOctScan = IconMedOctScan_1 = class IconMedOctScan extends IconBaseElement {
    render() {
        return html `${IconMedOctScan_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOctScan.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedOctScan = IconMedOctScan_1 = __decorate([
    customElement('zui-icon-med-oct-scan')
], IconMedOctScan);
export { IconMedOctScan };
